module.exports = __webpack_public_path__ + "img/loan-status5.4106e8d4.png";